module.exports = __webpack_public_path__ + "static/media/alarma.02551462.svg";